export default "__VITE_ASSET__7defce76__"